var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAward = function SvgAward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 48,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 34 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e81c5c",
    d: "m13 31 6 17 5-5 7 1-6-18Z",
    "data-name": "Path 65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4cc0ad",
    d: "m20 29-6 17-5-5-7 1 6-18Z",
    "data-name": "Path 66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3cb27",
    d: "m33.422 21.4-1.061-1.837-.388-.672.543-.555L34 16.82l-1.516-1.484-.484-.473.332-.589 1.041-1.848-1.848-1.041-.589-.332.168-.654.527-2.055-2.055-.527-.654-.168-.007-.676-.022-2.121-2.121.022-.676.007-.182-.651-.571-2.043-2.043.571-.651.182-.344-.581-1.08-1.826-1.826 1.08-.494.292L18.5 1.5 17 0l-1.5 1.5-.478.478-.585-.338L12.6.579l-1.061 1.837L11.2 3l-.653-.175-2.049-.549-.549 2.049-.175.653h-2.8v2.8l-.653.175-2.049.549.549 2.049L3 11.2l-.585.338L.578 12.6l1.061 1.837.388.672-.543.555L0 17.18l1.516 1.484.483.473-.332.589-1.041 1.848 1.848 1.041.589.332-.168.654-.527 2.055 2.055.527.654.168.007.676.022 2.121 2.121-.023.676-.007.182.651.571 2.043 2.043-.571.651-.182.344.581 1.08 1.826 1.826-1.08.494-.292.406.406L17 34l1.5-1.5.478-.478.585.338 1.837 1.061 1.061-1.837L22.8 31l.653.175 2.049.549.549-2.049.175-.653h2.8v-2.8l.653-.175 2.049-.549-.549-2.049L31 22.8l.585-.338Z",
    "data-name": "Path 67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7900",
    d: "M17 30a13 13 0 1 1 13-13 13.015 13.015 0 0 1-13 13m0-24a11 11 0 1 0 11 11A11.013 11.013 0 0 0 17 6",
    "data-name": "Path 68"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7900",
    d: "m17 9 2.4 4.861 5.365.78-3.882 3.784.916 5.343L17 21.245l-4.8 2.523.916-5.343-3.882-3.784 5.365-.78Z",
    "data-name": "Path 69"
  })));
};
export default SvgAward;